<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useMobile } from '@/components/hooks/useMobile'
import { useAccountStore } from '@/store/account'
import { useStakeStore } from '@/store/stake'
import { compareAddress } from '@/utils'
import StakeItem from './StakeItem.vue'
import WithdrawItem from './WIthdrawItem.vue'

const stakeStore = useStakeStore()
const accountStore = useAccountStore()
const isCcip = computed(() => accountStore.contractHelper?.adapter.isCcip)
const txList = computed(() =>
  stakeStore.txList
    .filter((item) => {
      if (!compareAddress(item.account, accountStore.account)) {
        return false
      }
      const activeChain = item.chainId === accountStore.currentNetworkChainId
      if (isCcip.value) {
        return activeChain
      }
      return ['bridge', 'withdraw'].includes(item.type) && activeChain
    })
    .slice(0, 5),
)

const { isMobile } = useMobile()

const withdrawStatus = computed(() => accountStore.withdrawStatus)

onMounted(() => {})
</script>

<template>
  <div :class="isMobile ? 'px-3 mt-6' : 'absolute right-[120px] top-[100px]'">
    <div class="flex flex-col gap-5">
      <StakeItem v-for="item in txList" :key="item.hash" :item="item" />
    </div>
    <div class="mt-5 flex flex-col gap-5">
      <WithdrawItem v-for="item in withdrawStatus" :key="item.nonce" :item="item" />
    </div>
  </div>
</template>

<style scoped lang="less"></style>
